import ColumnTypes from '../ReactComponent/SortableTable/constants';
import { formatDate } from '../../utils/func';

export const formName = 'ManageInvoices';

export const columns = [
  {
    id: 1,
    label: '',
    field: 'actions',
    sort: false,
    selected: true,
    default: true,
  },
  {
    id: 2,
    label: 'InvoiceNumber',
    field: 'invoiceNumber',
    sort: true,
    selected: true,
    default: true,
    disabled: true,
  },
  {
    id: 3,
    label: 'ShipmentNumber',
    field: 'shipmentNumber',
    sort: true,
    selected: true,
    default: true,
    disabled: true,
  },
  {
    id: 4,
    label: 'BillingAccount',
    field: 'billingAccount',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 5,
    label: 'InvoiceDate',
    field: 'invoiceDate',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 6,
    label: 'DueDate',
    field: 'dueDate',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 7,
    label: 'InvoiceAmount',
    field: 'invoiceAmount',
    sort: true,
    selected: false,
    default: false,
    type: ColumnTypes.Currency,
  },
  {
    id: 8,
    label: 'BalanceDue',
    field: 'balanceDue',
    sort: true,
    selected: false,
    default: false,
    type: ColumnTypes.Currency,
  },
];

export const historicalColumns = [
  {
    id: 1,
    label: '',
    field: 'actions',
    sort: false,
    selected: true,
    default: true,
  },
  {
    id: 2,
    label: 'InvoiceNumber',
    field: 'invoiceNumber',
    sort: true,
    selected: true,
    default: true,
    disabled: true,
  },
  {
    id: 3,
    label: 'BillingAccount',
    field: 'billingAccount',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 4,
    label: 'InvoiceDate',
    field: 'invoiceDate',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 5,
    label: 'DueDate',
    field: 'dueDate',
    sort: true,
    selected: true,
    default: true,
  },
  {
    id: 6,
    label: 'InvoiceAmount',
    field: 'invoiceAmount',
    sort: true,
    selected: false,
    default: false,
    type: ColumnTypes.Currency,
  },
  {
    id: 7,
    label: 'BalanceDue',
    field: 'balanceDue',
    sort: true,
    selected: false,
    default: false,
    type: ColumnTypes.Currency,
  },
];

export const novFirst2020 = new Date(2020, 10, 1, 0, 0, 0);
export const today = new Date();

const NUMBER_OF_DAYS = 60;
export const initialValues = {
  filterFromDate: formatDate(
    new Date(new Date().getTime() - NUMBER_OF_DAYS * 24 * 60 * 60 * 1000),
  ),
  filterToDate: formatDate(new Date()),
};
